import { isEffectiveSessionStatus } from './sessions';

/**
 * Resumen de las sesiones "efectivas" (`settled`/`free`) del proceso que se
 * está viendo en el modal de detalle de paciente — la Constancia de Atención
 * se genera solo con esto, acotada a ese proceso (réplica del comportamiento
 * de psima: no agrega otros procesos/profesionales del mismo paciente).
 */
export interface ConstanciaSourceSession {
  status?: string;
  date: string;
}

export interface ConstanciaSummary {
  sessionCount: number;
  /** Fecha ISO de la sesión efectiva más antigua. */
  firstSessionDate: string;
  /** Fecha ISO de la sesión efectiva más reciente. */
  lastSessionDate: string;
}

/**
 * Filtra únicamente sesiones "efectivas" (`settled`/`free` — ver `isEffectiveSessionStatus`,
 * mismo criterio que el resto de la app y que la Constancia de psima). Devuelve `null`
 * cuando no hay ninguna (la Constancia no puede emitirse).
 */
export function buildConstanciaSummary(sessions: ConstanciaSourceSession[]): ConstanciaSummary | null {
  const dates = sessions
    .filter((s) => isEffectiveSessionStatus(s.status))
    .map((s) => s.date)
    .sort();
  if (dates.length === 0) return null;
  return {
    sessionCount: dates.length,
    firstSessionDate: dates[0],
    lastSessionDate: dates[dates.length - 1],
  };
}
